class Board {
  static get spacer(){
    return 5;
  }
  constructor(length) {
    this.cuts = []
    this.length = length
  }

  available() {
    let takenLength = 0
    for (var cut of this.cuts) {
      takenLength += Number(cut.length);
    }
    const space = Number(this.cuts.length) * Number(Board.spacer)
    return (this.length - takenLength - space)
  }

  willFit(cut){
    return this.available() >= cut.length
  }

  addCut(cut) { this.cuts.push(cut) }

  inspect(){
    return this.cuts.map((cut) => { return `|-- ${cut.length} --|` }).join(" ")
  }
}
export default Board
